<template>
  <Container type="card-full">
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
        :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject"
        @pagechange="pagechange"
        :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'cosIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'cosname', fieldtype: 'C', title: '子平台名称',calculExpr:'', addNewRowFlg: false},
          { field: 'cosflgname', fieldtype: 'C', title: '标识',calculExpr:'',addNewRowFlg: false},
          { field: 'username', fieldtype: 'C',title: '创建人',calculExpr:'',addNewRowFlg: false},
          { field: 'costime', fieldtype: 'T',title: '创建时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']}
        ],
        cosform: false,
        cos: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addCos())
      this.$on('CHG', () => this.chgCos())
      this.$on('DEL', () => this.delCos())
      this.$on('BATCHCOS', () => this.addCosItem())
      this.$on('WMENU', () => this.setWMenu())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.cos = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addCos () {
        let form = {
          cosid: 0,
          cosflg: 2,
          coscomid: this.$store.getters.loginUser.usercomid,
          cosuserid: this.$store.getters.loginUser.userid
        }
        this.$router.push({name: 'cosForm', params: {form: form, type: 1}})
      },
      async chgCos () {
        if (!this.cos.cosid) {
          this.$message.warning('请选择一个平台!')
          return
        }
        this.cos.appends = []
        this.$router.push({name: 'cosForm', params: {form: this.cos, type: 2}})
      },
      async delCos () {
          this.$confirm('确定删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
          let data = await request({
            url: '/ywgl/cos/delCos',
            method: "post",
            data: {cosid: this.cos.cosid}
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            if(data.msg) {
              this.$message.warning(data.msg)
            } else {
              this.$message.error('删除失败！')
            }
          }
        })
      },
      async setWMenu () {
        if (!this.cos.cosid) {
          this.$message.warning('请选择一个平台!')
          return
        }
        this.$router.push({name: 'wmenuIndex', params: {form: this.cos}})
      },
      async addCosItem () {
        if (!this.cos.cosid) {
          this.$message.warning('请选择一个平台!')
          return
        }
        this.$router.push({name: 'cosItemForm', params: {form: this.cos}})
      },

      search (target) {},
      async save () {
        await request({
          url: '/ywgl/cos/addOrEdit',
          method: "post",
          data: this.cos
        })
        this.$message.success('操作成功')
        this.cosform = false
        if (!this.cos.cosid) {
          this.query.currPage = 1
        }
        await this.getPageList()
      },
      async cellClick (row) {
        this.cos = row.row
      },
      async viewProject(row) {
        this.cos = row.row
        this.$router.push({name: 'cosForm', params: {form: this.cos,innerbtn: this.btn.inner, type: 3}})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/cos/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
